export const productTypesAndFilters = {
  '3ca3eb03-7eac-477d-b253-15ce603d2550': {
    slug: 'acoustic-guitars',
    priceGoodMaxUsdCents: 75000,
    priceGreatMaxUsdCents: 25000,
    priceMinUsdCents: 15000,
    brandFilters: [
      'gretsch',
      'taylor',
      'martin',
      'ibanez',
      'prs',
      'fender',
      'epiphone',
      'cordoba',
    ],
  },
  'dfd39027-d134-4353-b9e4-57dc6be791b9': {
    slug: 'electric-guitars',
    priceGoodMaxUsdCents: 75000,
    priceGreatMaxUsdCents: 30000,
    priceMinUsdCents: 25000,
    brandFilters: [
      'squier',
      'fender',
      'prs',
      'gretsch',
      'gibson',
      'jackson',
      'charvel',
      'esp',
    ],
  },
  '53a9c7d7-d73d-4e7f-905c-553503e50a90': {
    slug: 'bass-guitars',
    priceGoodMaxUsdCents: 75000,
    priceGreatMaxUsdCents: 30000,
    priceMinUsdCents: 25000,
    brandFilters: [
      'fender',
      'ibanez',
      'squier',
      'gretsch',
      'hofner',
      'sterling',
    ],
  },
  '09055aa7-ed49-459d-9452-aa959f288dc2': {
    slug: 'amps',
    priceGoodMaxUsdCents: 50000,
    priceGreatMaxUsdCents: 20000,
    priceMinUsdCents: 10000,
    brandFilters: [
      'fender',
      'positive',
      'grid',
      'vox',
      'boss',
      'orange',
    ],
  },
  'fa10f97c-dd98-4a8f-933b-8cb55eb653dd': {
    slug: 'effects-and-pedals',
    priceGoodMaxUsdCents: 20000,
    priceGreatMaxUsdCents: 7500,
    priceMinUsdCents: 4000,
    brandFilters: [
      'keeley',
      'boss',
      'proco',
      'mxr',
      'dunlop',
      'ehx',
      'eqd',
      'jhs',
    ],
  },
  'b3cb9f8e-4cb6-4325-8215-1efcd9999daf': {
    slug: 'drums-and-percussion',
    priceGoodMaxUsdCents: 80000,
    priceGreatMaxUsdCents: 40000,
    priceMinUsdCents: 30000,
    brandFilters: [
      'ludwig',
      'alesis',
      'roland',
      'dw',
      'zildjian',
    ],
  },
  'b021203f-1ed8-476c-a8fc-32d4e3b0ef9e': {
    slug: 'pro-audio',
    priceGoodMaxUsdCents: 7500,
    priceGreatMaxUsdCents: 40000,
    priceMinUsdCents: 5000,
    brandFilters: [
      'shure',
      'focusrite',
      'universal',
      'audio',
      'sennheiser',
      'radial',
      'yamaha',
    ],
  },
  'd002db05-ab63-4c79-999c-d49bbe8d7739': {
    slug: 'keyboards-and-synths',
    priceGoodMaxUsdCents: 80000,
    priceGreatMaxUsdCents: 30000,
    priceMinUsdCents: 20000,
    brandFilters: [
      'korg',
      'teenage-engineering',
      'akai',
      'elektron',
      'arturia',
      'moog',
      'alm',
      'make-noise',
      'mutable-instruments',
    ],
  },
  'fb60628c-be4b-4be2-9c0f-bc5d31e3996c': {
    slug: 'folk-instruments',
    priceGoodMaxUsdCents: 50000,
    priceGreatMaxUsdCents: 20000,
    priceMinUsdCents: 15000,
    brandFilters: [
      'deering',
      'loar',
      'eastman',
      'hohner',
      'fender',
      'yamaha',
      'kala',
    ],
  },
};
